import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';





const styles = StyleSheet.create({
      
          to: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'left',
          },
          bold: {
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 5, 
          },
          paragraph: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'justify',
          },
          indent: {
            marginBottom: 5, 
            textAlign: 'justify',
            marginLeft: 10,
          },
          signature: {
            fontStyle: 'italic',    // for italic text
            textAlign: 'right',     // to align text to the right
            marginTop: 30,          // optional: add some space on top
          },
          
        });


        
const pensionCertificate = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>CERTIFICATE</Text>
                <Text style={style.subtitle}>(As required under para 2(1) and (b) G.R. dt. 21-7-83)</Text>

                <View style={style.solidLine} />

               
                <Text style={[style.paragraph, { marginTop: 10 }]}>
              Certificate that <Text style={style.ArialBold}>{result.institutionName}</Text> is recognized by the Department of Higher and Technical Education Maharashtra State and has been affiliated to a Non-agricultural University. The College in question is started since {result.establishmentDate}, on No Grant-in-aid basis and has been brought on 100% Grant -in-aid basis w.e.f. {result.aidedDate}.  Since then college is receiving grant-in-aid form the Department.  The college is managed by the <Text style={style.ArialBold}>{result.managementName}</Text>.
                </Text>
          
                <Text style={[style.paragraph, { marginTop: 10 }]}>
                Certified that <Text style={style.ArialBold}>{result.employeeName}</Text> Designation <Text style={style.ArialBold}>{result.designation}</Text> has served continuously as a Fill-time employee in the clear vacancy for the period from <Text style={style.ArialBold}>{result.dateOfAppointment}</Text> to <Text style={style.ArialBold}>{result.dateOfRetirement}</Text>.       
                </Text>
   
                <Text style={[style.paragraph, { marginTop: 10 }]}>
                The Categories of the post in which he has served during the above period are in the approved pattern by the state Government and has been paid his pay an allowances as per Government scales revised from time to time.
                </Text>

                      
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>


           </View>

);

export default pensionCertificate;